import { useExperimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery';

import type {
	PersonalizationQuery as PersonalizationQueryData,
	PersonalizationQueryVariables,
} from './useOnboardingEligible/__types__/UserPersonalizationQuery';

interface PersonalizationAttribute {
	name: string;
	value: string;
}

interface PersonalizationResponse {
	attributes: PersonalizationAttribute[] | null;
}

export const useExperimentalUserPersonalizationQuery = ({
	skip,
	onError,
	variables,
}: {
	skip?: boolean;
	onError?: (error: Error) => void;
	variables: PersonalizationQueryVariables;
}) => {
	return useExperimentalQuery<
		PersonalizationQueryData,
		PersonalizationQueryVariables,
		PersonalizationResponse
	>({
		url: ({ userId }) => `/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
		method: 'GET',
		parseResult: (response: PersonalizationResponse) => ({
			experimentalUserPersonalization: response,
		}),
		skip,
		onError,
		variables,
	});
};
